import { OAuthRedirect } from './OAuthRedirect';

export const ZoomOAuthRedirect = () => {
  return <OAuthRedirect provider="Zoom" />;
};
